import {
  BarChart3,
  LayoutDashboard,
  UserRound,
  UsersRound,
  Users,
  type LucideIcon,
} from 'lucide-react'

export type NavItem = {
  label: string
  to: string
  icon: LucideIcon
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', to: '/dashboard', icon: LayoutDashboard },
  { label: 'Leads', to: '/leads', icon: UsersRound },
  { label: 'Sales Team', to: '/sales-team', icon: Users },
  { label: 'Analytics', to: '/analytics', icon: BarChart3 },
  { label: 'Profile', to: '/profile', icon: UserRound },
]
